import type {SmallSALO} from '../types';
import {getSearchCriteriaFromSmallSALO} from './getSearchCriteriaFromSmallSALO';

export const decodeBase64Rules = (base64str: string) => {
	try {
		// trust is key here ¯\_(ツ)_/¯
		const small: SmallSALO = JSON.parse(
			Buffer.from(decodeURIComponent(base64str), 'base64').toString(),
		);
		return getSearchCriteriaFromSmallSALO(small);
	} catch (e) {}
};

export default decodeBase64Rules;
